import { AccessAction } from '../../common/model';
import { Invoice } from './invoice';
import { InvoiceRecipient, InvoiceBillingTransaction } from '../models';
import { PhxConstants } from '../../common';

export class InvoiceExtension {
    public static findRecipientIndex(invoice: Invoice, recipient: InvoiceRecipient): number {
        return InvoiceExtension.findRecipientIndexInCollection(invoice.InvoiceRecipients, recipient);
    }

    public static findClientRecipientIndex(invoice: Invoice, recipient: InvoiceRecipient): number {
        let itemIndex: number;

        if (recipient.InvoiceRecipientTypeId === PhxConstants.InvoiceRecipientType.ClientCC) {
            itemIndex = InvoiceExtension.findRecipientIndexInCollection(invoice.ClientCourtesyCopies, recipient);
        }

        return itemIndex;
    }

    public static findInternalRecipientIndex(invoice: Invoice, recipient: InvoiceRecipient): number {
        let itemIndex: number;

        if (recipient.InvoiceRecipientTypeId === PhxConstants.InvoiceRecipientType.InternalCC) {
            itemIndex = InvoiceExtension.findRecipientIndexInCollection(invoice.InternalCourtesyCopies, recipient);
        }

        return itemIndex;
    }

    private static findRecipientIndexInCollection(recipients: InvoiceRecipient[], recipient: InvoiceRecipient) {
        let itemIndex: number;

        if (recipient.TemporaryGuid && recipient.TemporaryGuid !== '') {
            itemIndex = recipients.findIndex(x => x.TemporaryGuid === recipient.TemporaryGuid);
        } else {
            itemIndex = recipients.findIndex(x => x.Id === recipient.Id);
        }

        return itemIndex;
    }

    public static recalculatePropertyValuesOnTransactionRemoved(invoice: Invoice, payload: any) {
        const isHeaderTermExistInList = invoice.InvoiceBillingTransactions
            .findIndex(n => n.BillingInvoiceTermId === invoice.BillingInvoiceTermId);
        const isHeaderTemplateExistInList = invoice.InvoiceBillingTransactions
            .findIndex(n => n.BillingInvoiceTemplateId === invoice.BillingInvoiceTemplateId);
        if (isHeaderTermExistInList === -1) {
            invoice.BillingInvoiceTermId = null;
        }
        if (isHeaderTemplateExistInList === -1) {
            invoice.BillingInvoiceTemplateId = null;
        }
        invoice.Total -= payload.TotalAmount;
        invoice.Tax -= payload.Tax;
        invoice.Subtotal -= payload.Subtotal;
    }

    public static getCurrentlySelectedInternalCC(invoice: Invoice): Array<number> {
        return InvoiceExtension.getCurrentlySelectedCC(invoice.InternalCourtesyCopies);
    }

    private static getCurrentlySelectedCC(recipients: InvoiceRecipient[]): Array<number> {
        return recipients
            .filter(i => i.InvoiceRecipientUserProfileId != null)
            .map(i => i.InvoiceRecipientUserProfileId);
    }

    // added to data service
    public static isEditable(invoice: Invoice, forceEdit: boolean) {
        if (!invoice) {
            return false;
        } else {
            return invoice.AccessActions.some((action: AccessAction) =>
              action.AccessAction === PhxConstants.EntityAccessAction.InvoiceEdit)
              && (invoice.StatusId === PhxConstants.InvoiceStatus.Draft || forceEdit);
        }
    }

    // moved to detail-notes-form-service -> can can removed from here
    public static getBillingTransactionNotes(invoice: Invoice, noteProperty: string): Array<string> {
        const noteItems = [];
        const notes = invoice.InvoiceBillingTransactions
            .map((bt: InvoiceBillingTransaction) => {
                if (noteItems.indexOf(bt[noteProperty]) < 0 && bt[noteProperty] && bt[noteProperty].trim() !== '') {
                    noteItems.push(bt[noteProperty]);
                }
            });
        return noteItems.sort();
    }
}
